import Liquidations_L from "views/Liquidations/lazy";
import LiquidationOtherProducts_L from "views/LiquidationOtherProducts/lazy";
import Supervision_L from "views/Supervision/lazy";
import Supervised_L from "views/Supervised/lazy";
import StartEndRoutes from "views/RoutesStatus/StartEndRoutes";
import { SettlementView } from "views/Closeouts-Settlements/SettlementView";
import { FillingOrderView } from "views/FillingOrder/FillingOrderView";
import { ActionTypes } from "redux/reducers/liquidations/types";
import { LiquidationOtherProductsTypes } from "redux/reducers/liquidationOtherProducts/types";
import { PERMISSIONS } from "router/permissions";

import AssessmentIcon from "@material-ui/icons/Assessment";

const LiquidationErrorConf = {
  reducer: "liquidations",
  restoreKey: ActionTypes.RESTORE_INITIAL
}

const LiquidationOtherProductsErrorConf = {
  reducer: "liquidationOtherProducts",
  restoreKey: LiquidationOtherProductsTypes.RESTORE_INITIAL_LIQUIDATION_OTHER_PRODUCTS
}

const { 
  ENDOWMENTS, 
  SUPERVISION, 
  SUPERVISION_DECRYPT,
  ENDOWMENTS_ORDERS_VIEW,
  ENDOWMENTS_SETTLEMENTS,
  ENDOWMENTS_SETTLEMENTS_OTHER_PRODUCTS,
} = PERMISSIONS

export const salesRoutes = [
  {
    collapse: true,
    name: "Ventas",
    icon: AssessmentIcon,
    state: "endownmentSection",
    inSidebar: true,
    isProtected: true,
    rule: "ENDOWMENTS",
    views: [
      {
        path: "/lista-liquidaciones",
        name: "Liquidaciones",
        mini: "LQ",
        component: Liquidations_L,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: ENDOWMENTS_SETTLEMENTS,
        ...LiquidationErrorConf
      },
      {
        path: "/supervision",
        name: "Supervisión",
        mini: "SV",
        component: Supervision_L,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: SUPERVISION,
      },
      {
        path: "/supervised",
        name: "Supervisado",
        mini: "SD",
        component: Supervised_L,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: SUPERVISION_DECRYPT,
      },
      {
        path: "/inicio_fin_ruta",
        name: "Inicio-Fin Rutas",
        mini: "IFR",
        component: StartEndRoutes,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: ENDOWMENTS,
      },
      {
        path: "/rutas-liquidaciones/:id",
        name: "Liquidaciones",
        mini: "LQ",
        component: SettlementView,
        layout: "/admin",
        inSidebar: false,
        isProtected: true,
        rule: ENDOWMENTS,
      },
      {
        path: "/ordenes-llenado",
        name: "Ordenes de Llenado",
        mini: "OL",
        component: FillingOrderView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: ENDOWMENTS_ORDERS_VIEW,
      },
      {
        path: "/liquidacion-otros-productos",
        name: "Liquidación Otros Productos",
        mini: "LOP",
        component: LiquidationOtherProducts_L,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: ENDOWMENTS_SETTLEMENTS_OTHER_PRODUCTS,
        ...LiquidationOtherProductsErrorConf
      },
    ].sort((a, b) => (a.name < b.name ? -1 : 1)),
  },
]